import EventsFilterModal from './EventsFilterModal';

export default EventsFilterModal;
